// extracted by mini-css-extract-plugin
export var createdDate = "_no-1";
export var divider = "_no-2";
export var headerDivider = "_no-3";
export var messagesCard = "_no-0";
export var messagesContainer = "_no-6";
export var messagesContainerWrapper = "_no-4";
export var showLeftPanelButton = "_no-8";
export var topButtons = "_no-7";
export var withPadding = "_no-5";